import { render, staticRenderFns } from "./MotionAnalyze.vue?vue&type=template&id=0cca815f&scoped=true&"
import script from "./MotionAnalyze.vue?vue&type=script&lang=ts&"
export * from "./MotionAnalyze.vue?vue&type=script&lang=ts&"
import style0 from "./MotionAnalyze.vue?vue&type=style&index=0&id=0cca815f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cca815f",
  null
  
)

export default component.exports